module.exports = __webpack_public_path__ + "static/media/logo.3809a0fe.png";